import {
  Home,
  Users,
  PackageSearch,
  ShoppingCart,
  ReceiptText,
  Factory,
  Boxes,
  DollarSign,
  ClipboardList,
  FolderTree,
  Truck,
  Tag,
  Megaphone,
  BarChart,
  Bell,
  Image,
  Store,
  FileText,
  Mail,
  RefreshCcw,
  Settings,
  Plus,
  ClipboardListIcon,
  AlertTriangle,
  Shield,
  UserCog,
  LinkIcon,
  Flag,
  Globe,
  Ticket,
  CreditCard,
  AppWindow,
} from "lucide-react";

import ADMIN_PATHS from "../ADMIN_PATHS";

export const navCategories = [
  {
    heading: "Store Management",
    icon: Home,
    links: [
      { to: ADMIN_PATHS.DASHBOARD, icon: Home, label: "Dashboard" },
      { to: ADMIN_PATHS.PRODUCTS.BASE, icon: Boxes, label: "Product Management" },
      { to: ADMIN_PATHS.PRODUCTS.CATEGORIZED, icon: FolderTree, label: "Categorized Products" },
      // { to: ADMIN_PATHS.CATEGORY, icon: FolderTree, label: "Category Management" },
      { to: ADMIN_PATHS.ORDERS, icon: ReceiptText, label: "Order Management" },
      { to: ADMIN_PATHS.B2C_REVIEWS, icon: ClipboardList, label: "Reviews & QnA Management" },
      { to: ADMIN_PATHS.DISPUTES, icon: AlertTriangle, label: "Support Management" },
      { to: ADMIN_PATHS.USERS, icon: Users, label: "Users Management" },
    ],
  },
  {
    heading: "Partners Management",
    icon: Factory,
    links: [
      {
        to: ADMIN_PATHS.PARTNERAPPLICATIONMANAGEMENT,
        icon: FileText,
        label: "Applications",
      },
      {
        to: ADMIN_PATHS.PARTNERLIST,
        icon: Store,
        label: "Partner List",
      },
      {
        to: ADMIN_PATHS.PARTNERPRODUCTMANAGEMENT,
        icon: Truck,
        label: "Partner Products",
      },
    ],
  },
  {
    heading: "Integration",
    icon: LinkIcon,
    links: [
      { to: ADMIN_PATHS.ALIEXPRESS, icon: PackageSearch, label: "AliExpress Integration" },
      { to: ADMIN_PATHS.SHIPPING, icon: Truck, label: "Shipping" },
      { to: ADMIN_PATHS.PAYMENT_GATEWAYS, icon: CreditCard, label: "Gateways" },
    ],
  },
  {
    heading: "Finance Management",
    icon: DollarSign,
    links: [
      { to: ADMIN_PATHS.FINANCE, icon: DollarSign, label: "Finance Management" },
      { to: ADMIN_PATHS.PRICING, icon: DollarSign, label: "Pricing & Profit Management" },
    ],
  },
  {
    heading: "Marketing & Content",
    icon: Megaphone,
    links: [
      { to: ADMIN_PATHS.CAMPAIGNS, icon: Tag, label: "Campaigns & Discounts" },
      { to: ADMIN_PATHS.VOUCHER, icon: Ticket, label: "Voucher Management" },
      { to: ADMIN_PATHS.MARKETING, icon: Megaphone, label: "Marketing & Content" },
      { to: ADMIN_PATHS.MEDIA, icon: Image, label: "File & Media Manager" },
    ],
  },
  {
    heading: "Analytics & System",
    icon: BarChart,
    links: [
      { to: ADMIN_PATHS.ANALYTICS, icon: BarChart, label: "Analytics & Reports" },
      { to: ADMIN_PATHS.SEO_META, icon: Globe, label: "SEO/Metadata (cherrfy.com)" },
      { to: ADMIN_PATHS.COUNTRY_CURRENCY, icon: Flag, label: "Country & Currency Management" },
      { to: ADMIN_PATHS.NOTIFICATIONS, icon: Bell, label: "Notifications" },
      { to: ADMIN_PATHS.BACKUP, icon: RefreshCcw, label: "Backup & Restore" },
      { to: ADMIN_PATHS.MAIL_MANAGEMENT.BASE, icon: Mail, label: "Mail Management" },
      { to: ADMIN_PATHS.SETTINGS, icon: Settings, label: "System Settings" }, 
      { to: ADMIN_PATHS.ADMIN.BASE, icon: UserCog, label: "Admin & Role Management" },
    ],
  },
  {
    heading: "Application",
    icon: AppWindow,
    links: [
      { to: ADMIN_PATHS.APPLICATION.PUSH_NOTIFICATION, icon: Bell, label: "Push Notification" },
    ],
  },
];

export const advancedOptions = [
  { to: ADMIN_PATHS.ADMIN.BASE, icon: Shield, label: "Security Settings" },
  { to: ADMIN_PATHS.SETTINGS, icon: Settings, label: "Advanced System Settings" },
  { to: ADMIN_PATHS.TERMSMANAGER, icon: Settings, label: "Terms Management" },
];

export const sidebarCtas = [
  {
    to: ADMIN_PATHS.PRODUCTS.ADD,
    icon: Plus,
    label: "Add Product",
    category: "CTA",
  },
  {
    to: ADMIN_PATHS.STORE,
    icon: LinkIcon,
    label: "Visit Store",
    category: "External",
    external: true,
  },
];

export function getAdminSidebarSearchItems() {
  const items = [];

  for (const cat of navCategories) {
    for (const link of cat.links || []) {
      items.push({
        ...link,
        category: cat.heading,
      });
    }
  }

  for (const link of advancedOptions) {
    items.push({
      ...link,
      category: "Advanced Options",
    });
  }

  for (const link of sidebarCtas) {
    items.push({
      ...link,
      category: link.category || "Other",
    });
  }

  // De-dupe by (to + label)
  const seen = new Set();
  return items.filter((it) => {
    const key = `${it.to}::${it.label}`;
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}
